/**
 * Extracts the filename from a Content-Disposition header value.
 * Quoted filenames take priority over unquoted ones.
 * @param contentDisposition - The raw Content-Disposition header value
 * @returns The extracted filename, or null if none is found
 */
export function extractFilename(
  contentDisposition: string | null,
): string | null {
  if (!contentDisposition) {
    return null;
  }

  // E.g. Content-Disposition: attachment; filename="example.pdf"
  const quotedMatch = /filename="(.+?)"/.exec(contentDisposition);
  if (quotedMatch) {
    return quotedMatch[1];
  }

  // E.g. Content-Disposition: attachment; filename=another-example.jpg
  const unquotedMatch = /filename=([^;\s]+)/.exec(contentDisposition);
  return unquotedMatch ? unquotedMatch[1] : null;
}
